export const environment = {
  appHost: 'https://qa.hub.veratrak.com',
  apiHost: 'https://pfexffwgg5.execute-api.eu-west-1.amazonaws.com/Prod',
  cognito: {
    poolName: 'watchtower-qa',
    clientId: '217mesv6ts45n74n9af2v3ab6n',
    redirect: 'https://qa.watchtower.hub.veratrak.com'
  }
};
